<section class="blog-area space bg-smoke" data-bg-src="assets/img/shape/line-patter.png">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-4">
                <div class="sec_title_static">
                    <div class="sec_title_wrap">
                        <div class="title-area blog12-titlebox text-center text-lg-start pe-xl-5 mb-sm-0">
                            <span class="sub-title text-anime-style-2">News & Blogs</span>
                            <h2 class="sec-title text-anime-style-3">News & Articles</h2>
                            <div class="wow fadeInUp"><a routerLink="/latest-news"
                                    class="th-btn style4 th-radius th-icon">See
                                    More Articles <i class="fa-light fa-arrow-right-long"></i></a></div>
                        </div>
                        <div class="blog12-shape d-none d-sm-block">
                            <img src="assets/img/shape/blog-present.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-8">
                <div *ngIf="blogs && blogs.length > 0" class="blog-grid4-static-wrap">
                    <div *ngFor="let blog of blogs" class="col-12 blog-grid12 blog-grid4_wrapp">
                        <div class="blog-grid4 th-ani style4 mt-24">
                            <div class="blog-img global-img">
                                <img [src]="blog.featured_image" (error)="onImageError($event)" alt="{{ blog.title }}"
                                    class="blog-feature-img" />
                            </div>
                            <div class="box-content">
                                <div class="blog-meta">
                                    <a class="author" routerLink="/latest-news/{{ blog.slug }}">{{ blog.published_at |
                                        date:'dd MMMM yyyy' }}</a>
                                    <a routerLink="/latest-news/{{ blog.slug }}">by Team Xipetech</a>
                                </div>
                                <h3 class="box-title">
                                    <a routerLink="/latest-news/{{ blog.slug }}" [innerHTML]="blog.title">{{ blog.title ?? '' }}</a>
                                </h3>
                                <p class="sec-text" [innerHTML]="blog.excerpt">{{ blog.excerpt ?? '' }}</p>
                                <a routerLink="/latest-news/{{ blog.slug }}"
                                    class="th-btn style4 th-radius th-icon">Read More <i
                                        class="fa-light fa-arrow-right-long"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>